import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './OrderTracking.less';

export default class OrderTracking extends OfficialPage {
  state = {}

  constructor(props) {
    super(props);
    document.title = '订单跟踪';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.orderId = options.orderId
  }

  componentDidMount() {
    this.getTransport(this.orderId)
  }

  getTransport = order_id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getTransportOrderFlow',
      method: 'post',
      data: {
        order_id: order_id
      },
      success: function (res) {
        console.log(res.data.reverse())
        console.log(res.data)
        that.setData({
          orderFlow: res.data
        })
      }
    })
  }

  render() {
    const { orderFlow } = this.state
    return (
      <div className="official-page order-tracking">
        <TopNav title="订单跟踪"/>
        {orderFlow && orderFlow.map((item, index) => {
          return <div className="order-block" key={index}>
            <label className="order-point"></label>
            <div className="order-content">
              <span className="order-message">{item.content.msg}</span>
              <span className="order-time">{item.op_time}</span>
              <div></div>
            </div>
            <span className="order-line"></span>
          </div>
        })}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/order-tracking/OrderTracking.jsx